/**
 * Single source of truth: resume section / portfolio category title -> Tabler icon.
 *
 * Resume section titles (resume_structures.title) and portfolio category labels
 * (talent_portfolios.label) are agency-configurable, so this matches by keyword and
 * falls back to ti-list. Keep this the ONLY place that maps a section title to an icon
 * so the portfolio Resume tab and the search-results Talent Resume modal stay consistent.
 *
 * Built by Laravel Mix to public/js/components/resume-section-icons.js and loaded as a
 * plain <script>, exposing window.resumeSectionIcon(title) -> 'ti-...' (Tabler icon class).
 */
(function (w) {
    // First match wins -> order specific before generic.
    var RULES = [
        [/special skill|\bskills?\b/i, 'ti-star'],
        [/voice ?over|voice/i, 'ti-microphone-2'],
        [/television|\btv\b/i, 'ti-device-tv'],
        [/film|cinema/i, 'ti-movie'],
        [/commercial/i, 'ti-shopping-bag'],
        [/industrial/i, 'ti-building-factory-2'],
        [/theat/i, 'ti-masks-theater'],
        [/training|education/i, 'ti-school'],
        [/music/i, 'ti-music'],
        [/dance|dancing/i, 'ti-shoe'],
        [/sport|athletic/i, 'ti-ball-football'],
        [/language|accent/i, 'ti-language'],
        [/award|honou?r/i, 'ti-trophy'],
        [/print|photo|modeling/i, 'ti-photo'],
        [/live event|promotion|promo/i, 'ti-speakerphone'],
        [/automobile|vehicle|\bcar\b|driving/i, 'ti-car'],
        [/audition|\blinks?\b/i, 'ti-link'],
        [/internet|new media|\bweb\b|online|social/i, 'ti-world'],
        [/appearance|\blooks?\b/i, 'ti-mood-smile'],
        [/measurement|sizing/i, 'ti-ruler-2'],
        [/animal|\bdog\b|\bpet\b|\bpaw\b/i, 'ti-paw'],
        [/permit|minor|trust|legal|document/i, 'ti-file-text']
    ];

    w.resumeSectionIcon = function (title) {
        var t = (title == null ? '' : String(title));
        for (var i = 0; i < RULES.length; i++) {
            if (RULES[i][0].test(t)) { return RULES[i][1]; }
        }
        return 'ti-list';
    };
})(window);
